import { render, staticRenderFns } from "./BookMarkedLesson.vue?vue&type=template&id=50bc922f&scoped=true&"
import script from "./BookMarkedLesson.vue?vue&type=script&lang=js&"
export * from "./BookMarkedLesson.vue?vue&type=script&lang=js&"
import style0 from "./BookMarkedLesson.vue?vue&type=style&index=0&id=50bc922f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc922f",
  null
  
)

export default component.exports